<template>
  <a-tabs style="background: #fff;" type="card">
    <a-tab-pane key="1" tab="基本信息">
      <base-info></base-info>
    </a-tab-pane>
    <!-- <a-tab-pane key="2" tab="进出水配置">
      <sewage-plant-inout-conf-form></sewage-plant-inout-conf-form>
    </a-tab-pane>
    <a-tab-pane key="3" tab="自动运行">
      <auto-running-conf-form></auto-running-conf-form>
    </a-tab-pane>-->
  </a-tabs>
</template>

<script>
  import BaseInfo from "./modules/BaseInfo";
  import SewagePlantInoutConfForm from "./modules/SewagePlantInoutConfForm";
  import AutoRunningConfForm from "./modules/AutoRunningConfForm";

  export default {
    name: 'SewegePlantListForm',
    components: {
      BaseInfo,
      SewagePlantInoutConfForm,
      AutoRunningConfForm,
    },
    data () {
      return {
      }
    },
    created () {

    },
    methods: {
    }
  }
</script>